import { createContext, useContext, useEffect, useState } from 'react';
import { axios } from '../../../utils/axios';
import { CostingRequestsContext } from '../../../contexts/CostingRequest';
import { showAlert } from '../../../utils/alerts';
import { useNavigate } from 'react-router-dom';
import { routes } from '../../../routes';

export const StockPriceContext = createContext();

export const Provider = ({ children }) => {
  const navigate = useNavigate();
  const { getSkus } = useContext(CostingRequestsContext);
  const [plantsLoading, setPlantsLoading] = useState(false);
  const [selectedSku, setSelectedSku] = useState({});
  const [countries, setCountries] = useState([]);
  const [salesOrgs, setSalesOrgs] = useState([]);
  const [form, setForm] = useState({});
  const [plants, setPlants] = useState([]);
  const [submitLoading, setSubmitLoading] = useState(false);

  const reset = () => {
    setPlants([]);
  };

  const fetchCountries = async () => {
    try {
      const { data } = await axios.get('/costing-request/distinct-countries');
      const countries = (data.data || []).filter((country) => country.PlantPrefix);
      setCountries(
        countries.map((item) => {
          return {
            label: item.Country,
            value: item.PlantPrefix,
          };
        }),
      );
    } catch (e) {
      console.log(e);
    }
  };

  const getSalesOrgs = async () => {
    try {
      const { data } = await axios.get(`/costing-request/sales-orgs`);
      setSalesOrgs(data.data);
    } catch (e) {
    } finally {
    }
  };

  useEffect(() => {
    fetchCountries();
    getSalesOrgs();
    getSkus();
  }, []);

  const fetchPlants = async () => {
    try {
      const { material, country_code, salesorg } = { ...form };
      setPlantsLoading(true);
      const { data } = await axios.post('/costing-request/stock-price-extension-new-plants', {
        material: material,
        country_code: `${country_code}**`,
        salesorg: salesorg,
        // material: '91224',
        // country_code: 'GB**',
        // salesorg: 'GB11',
      });
      setPlants(data.openPlants);
    } catch (e) {
      showAlert(e, 'error');
    } finally {
      setPlantsLoading(false);
    }
  };

  const createExtensionRequest = async () => {
    try {
      setSubmitLoading(true);
      const editablePlants = [];
      plants.forEach((plant) => {
        if (plant.isEditable)
          editablePlants.push({
            ...plant,
            material_description: form.material_description,
            country: form.country,
          });
      });

      if (editablePlants.length === 0) {
        showAlert({ message: 'No editable plants to submit' }, 'error');
        return;
      }

      await axios.post(`/costing-request/stock-price-extension-new-plants-submit`, editablePlants);
      showAlert({ message: 'Stock Price has been updated successfully' }, 'success');
      navigate(routes.stockPriceExtension().root);
    } catch (e) {
      showAlert(e, 'error');
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <StockPriceContext.Provider
      value={{
        selectedSku,
        setSelectedSku,
        countries,
        salesOrgs,
        form,
        setForm,
        fetchPlants,
        plants,
        plantsLoading,
        submitLoading,
        createExtensionRequest,
        reset,
      }}
    >
      {children}
    </StockPriceContext.Provider>
  );
};
